module.exports = __webpack_public_path__ + "static/media/background.1ce4395d.png";